import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthenticated, localStorageMethod } from 'src/common/config/FunctionHelper';
import { Box, CircularProgress } from '@mui/material';
import { paths } from 'src/common/config/TextMessage';
import Login from 'src/content/login/components/Login';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { loginSxs } from '../login/components/loginSxs';
import { overView } from 'src/common/CommomSxs';

/**
 * Overview component for handling the landing page before login.
 * Redirects to the site audit page if the user is already authenticated.
 */
const Overview = () => {
  const [authenticatedUser, setAuthenticatedUser] = useState(
    getAuthenticated()
  );
  const navigate = useNavigate();
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  let stripeLoader = useSelector(
    (state: RootState) => state.siteAudit.stripeLoader
  );

  // Hanlde logout to clear query cache
  useEffect(() => {
    const isAuthenticated = getAuthenticated();
    if (isAuthenticated === 'false') {
      if (typeof window !== 'undefined' && (window as any).__TANSTACK_QUERY_CLIENT__) {
        try {
          (window as any).__TANSTACK_QUERY_CLIENT__.clear();
        } catch (e) {
          console.error('Failed to clear query client cache', e);
        }
      }
    }
  }, []);

  useEffect(() => {
    // Redirect only a signed-in user. Treating any other value (including an
    // absent flag on a fresh browser) as signed-out matches the route guard,
    // so the two cannot ping-pong between /signin and /dashboard.
    const isAuthenticated: any = getAuthenticated();
    if (isAuthenticated !== 'true') return;

    const isOpenOrbitAIModal =
      localStorageMethod('get', 'open_orbit_ai_modal') === 'true';

    if (isOpenOrbitAIModal) {
      return navigate(paths?.dashboard);
    }

    // If activePlanName is present, we can navigate immediately
    if (activePlanName) {
      if (activePlanName !== planDetails.free) {
        return navigate(paths?.dashboard);
      } else {
        return navigate(paths?.externalScans);
      }
    }

    // Wait until subscription details API call is finished (stripeLoader becomes false)
    if (stripeLoader === false && !activePlanName) {
      // If we finished loading and still no plan name, default to dashboard
      return navigate(paths?.dashboard);
    }
  }, [activePlanName, stripeLoader]);

  return (

    <Box sx={loginSxs?.containerSx}>
      {authenticatedUser === 'true' && (
        // Display a spinner while the authenticated user is redirected away
        <Box sx={overView.spinnerSx}>
          <CircularProgress size={64} disableShrink thickness={3} />
        </Box>
      )}
      {authenticatedUser !== 'true' && <Login />}
    </Box>
  );
};

export default Overview;
